import { unitDriversByDjtId } from '../../../graphql/custom_queries';
import PropTypes from 'prop-types';
import { generateClient } from 'aws-amplify/api';

const client = generateClient();

export const fetchUnitDriversByDjtId = async (djtId) => {
  try {
    const response = await client.graphql({
      query: unitDriversByDjtId,
      variables: { djtId },
    });

    const results = response.data.driverByDjtId.items;
    return results;
    
  } catch (err) {
    return ('error fetchUnitDriversByDjtId: ', [err]);
  }
}

fetchUnitDriversByDjtId.propTypes = {
  djtId: PropTypes.string.isRequired,
};
